"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigCollection = exports.ParseError = void 0;
const types_1 = require("./types");
class ParseError extends Error {
    constructor(message, cause) {
        super(message);
        this.cause = cause;
    }
}
exports.ParseError = ParseError;
function safeParse(json) {
    try {
        return {
            data: types_1.AnyConfigSchema.parse(JSON.parse(json)),
            success: true,
        };
    }
    catch (error) {
        if (error instanceof Error) {
            return { success: false, error };
        }
        return {
            success: false,
            error: new ParseError("An unknown error occurred during parsing", error),
        };
    }
}
class ConfigCollection {
    static fromValues(values, options) {
        const result = safeParse(values);
        if (!result.success) {
            const parseError = new ParseError("Failed to deserialize config", result.error);
            if (options === null || options === void 0 ? void 0 : options.throw) {
                throw parseError;
            }
            console.error(parseError);
            return ConfigCollection.empty();
        }
        return new ConfigCollection(Array.isArray(result.data)
            ? (0, types_1.minimalToMap)(result.data)
            : (0, types_1.standardToMap)(result.data));
    }
    static empty() {
        return new ConfigCollection(new Map());
    }
    toJson(format) {
        switch (format) {
            case "standard":
                return JSON.stringify((0, types_1.mapToStandard)(this.config));
            case "minimal":
                return JSON.stringify((0, types_1.mapToMinimal)(this.config));
        }
    }
    constructor(config) {
        this.config = config;
    }
    getBoolean(configName) {
        const config = this.config.get(configName);
        if (!config) {
            return { error: types_1.ConfigError.NotFound };
        }
        const { value } = config;
        if (typeof value !== "boolean") {
            return { error: types_1.ConfigError.IncorrectType, received: value };
        }
        return { value: value };
    }
    getString(configName) {
        const config = this.config.get(configName);
        if (!config) {
            return { error: types_1.ConfigError.NotFound };
        }
        const { value } = config;
        if (typeof value !== "string") {
            return { error: types_1.ConfigError.IncorrectType, received: value };
        }
        return { value: value };
    }
    getNumber(configName) {
        const config = this.config.get(configName);
        if (!config) {
            return { error: types_1.ConfigError.NotFound };
        }
        const { value } = config;
        if (typeof value !== "number") {
            return { error: types_1.ConfigError.IncorrectType, received: value };
        }
        return { value: value };
    }
    getStringList(configName) {
        const config = this.config.get(configName);
        if (!config) {
            return { error: types_1.ConfigError.NotFound };
        }
        const { value } = config;
        if (!Array.isArray(value) || !value.every((x) => typeof x === "string")) {
            return { error: types_1.ConfigError.IncorrectType, received: value };
        }
        return { value: value };
    }
    getNumberList(configName) {
        const config = this.config.get(configName);
        if (!config) {
            return { error: types_1.ConfigError.NotFound };
        }
        const { value } = config;
        if (!Array.isArray(value) || !value.every((x) => typeof x === "number")) {
            return { error: types_1.ConfigError.IncorrectType, received: value };
        }
        return { value: value };
    }
}
exports.ConfigCollection = ConfigCollection;
